import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbMenuItem } from '@nebular/theme';
import { RouterModule, Routes } from '@angular/router';
import { UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { CategoriesComponent } from './categories.component';
//link:"/admin/categories/category/"+productCategoryId,
export const categoryroutes: Routes = [
  {
    path:'',
    component:CategoriesComponent,
    children:[
    {
      path:'category/:productCategoryId',
      component:CategoriesComponent,
      
    },
    {
      path:'category/:productCategoryId/content',
      component:CategoriesComponent
    },
    {
      path:'category/:productCategoryId/products',
      component:CategoriesComponent
    },
    {
      path:'category/:productCategoryId/parties',
      component:CategoriesComponent
    },
    {
      path:'category/:productCategoryId/parent-categories',
      component:CategoriesComponent
    },
    {
      path:'category/:productCategoryId/child-categories',
      component:CategoriesComponent
    }

    ]
  }
]

const MENU_ITEMS:NbMenuItem[] = [];
const headerTitle:string = "Category Management Application";
const path:string = "categories";
const menuTag:string = "categoriesMenu"


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(categoryroutes),
    UbsViewContainersModule
  ]
})
export class CategoryRoutingModule { 
  menuAndTitleOptions = {path:path,menuItems:MENU_ITEMS,headerTitle:headerTitle,menuTag:menuTag};
  constructor(private viewContainerService:ViewContainersService){
    this.viewContainerService.menuAndTitleOptions$.next([... this.viewContainerService.menuAndTitleOptions$.getValue(),this.menuAndTitleOptions]);
    this.viewContainerService.activeMenuTag$.next(menuTag);
    //this.viewContainerService.addMenuAndTitleOptions(menuAndTitleOptions)
  }
}
